import styled from 'styled-components';

export const Root = styled.div`
    width: 100vw;
    max-width: 100w;
    height: 100vh;
    overflow: hidden;
    position: relative;
`

export const Header = styled.div`
    display: flex;
    flex: 1;
    padding-top: 4px;
    padding-bottom: 28px;
    padding-left: 46px;
    padding-right: 46px;
    justify-content: flex-end;
`

export const Text = styled.span`
    font-size: 16px;
`

